"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TypeFillerVisitor = void 0;
const sheet_db_1 = require("../../../sheet_db");
const visitor_base_1 = require("./visitor.base");
class TypeFillerVisitor extends visitor_base_1.VisitorBase {
    visitColumn(node) {
        const column = node.column;
        if (column) {
            node.dataType = column.type;
        }
        else {
            node.dataType = sheet_db_1.ColumnType.STRING;
        }
    }
    visitFormula(node) {
        const formulaDef = sheet_db_1.FormulaLibrary[node.abstractText];
        node.formulaDef = formulaDef;
    }
}
exports.TypeFillerVisitor = TypeFillerVisitor;
